var _path, _mask, _g, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilitiDc22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.381C23.75 19.0412 18.3809 25.4265 12.0025 29.6979C5.16984 24.9644 0.25 19.0453 0.25 12.381C0.25 5.67379 5.51796 0.25 12 0.25C18.482 0.25 23.75 5.67379 23.75 12.381Z",
    fill: "white",
    stroke: "#008480",
    strokeWidth: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 22
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7754 12.381C23.7754 19.0592 18.3892 25.4557 12.0022 29.7286C5.1603 24.9922 0.224609 19.0629 0.224609 12.381C0.224609 5.66052 5.5032 0.224609 12 0.224609C18.4968 0.224609 23.7754 5.66052 23.7754 12.381Z",
    fill: "#FFC30F",
    stroke: "#008480",
    strokeWidth: 0.449219
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.25,
    r: 8.25,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2214 9.61133L15.5728 15.5846L16.0734 13.0508L18.4384 12.1844L12.2214 9.61133Z",
    fill: "#008480"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7027 12.1846H6L7.88142 13.8978L7.42751 16.4381L12.7027 12.1846Z",
    fill: "#ABE1FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.413 11.3266L13.7643 5.35551L11.3823 6.17609L9.47119 4.5L10.413 11.3266Z",
    fill: "#FFC30F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilitiDc22);
export default __webpack_public_path__ + "static/media/mobiliti_dc22.3466198aee79141a0a7ed306457169b2.svg";
export { ForwardRef as ReactComponent };